/* RESPONSIBLE TEAM: team-frontend-tech */
import Fragment from 'ember-data-model-fragments/fragment';
import { attr } from '@ember-data/model';

export default Fragment.extend({
  type: attr('string'),
});
